import Notifier from '@utils/notifier';
angular.module('eva2-angular').service('Notifier', function() {
  'use strict';
  return Notifier;
});
